/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_Table_IntroInputs */

const en_pc_alt_table_intro = /** @type {(inputs: Pc_Alt_Table_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facts come from each project's own website or repository, checked in October 2026. Prices change, so check with the vendor before you buy.`)
};

const zh_pc_alt_table_intro = /** @type {(inputs: Pc_Alt_Table_IntroInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`信息取自各项目自己的网站或代码仓库，于 2026 年 10 月核对。价格可能变化，购买前请以厂商信息为准。`)
};

/**
* | output |
* | --- |
* | "Facts come from each project's own website or repository, checked in October 2026. Prices change, so check with the vendor before you buy." |
*
* @param {Pc_Alt_Table_IntroInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_table_intro = /** @type {((inputs?: Pc_Alt_Table_IntroInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_Table_IntroInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_table_intro(inputs)
	return zh_pc_alt_table_intro(inputs)
});
export { pc_alt_table_intro as "pc.alt.table_intro" }